export const filterBtagBasedBonuses = (items, userTrackingCodes) => items?.filter((el) => {
  const { name } = el.items.common;

  if (name.toLowerCase().includes('btag=')) {
    return name.includes(`btag="${userTrackingCodes.btag}"`);
  }

  return true;
});
